import QrCodeIconLink from '../../../images/icons/qr-code.svg';

const QrCodeIcon = ({ ...props }) => (
  <div
    data-testid="qr-code-icon-component"
    className="qrcode-icon-component"
    {...props}
  >
    <img
      data-testid="qr-code-icon-image"
      src={QrCodeIconLink}
    />
  </div>
);

export default QrCodeIcon;
